'use strict';

/**
 * View for rendering a single set in share menu
 *
 * @category   View
 * @module     community
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoItemView = require('base/Colido.ItemView');

var template = require('../../templates/partials/share-sets-empty.hbs');

var ShareSetsEmpty = ColidoItemView.extend({
    template: template,

    tagName: 'li',
});

module.exports = ShareSetsEmpty;